import { render } from "./TenantBaselineOptions.vue?vue&type=template&id=40cbbb37&scoped=true"
import script from "./TenantBaselineOptions.vue?vue&type=script&lang=js"
export * from "./TenantBaselineOptions.vue?vue&type=script&lang=js"

import "./TenantBaselineOptions.vue?vue&type=style&index=0&id=40cbbb37&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40cbbb37"]])

export default __exports__